import React from 'react'
import BrowserRouter from 'react-router-dom/BrowserRouter'
import Route from 'react-router-dom/Route'
import AppFrame from './AppFrame'
import PopupWrapper from './shared/components/popup/PopupWrapper'
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider'
import createMuiTheme from '@material-ui/core/styles/createMuiTheme'
import PortalTheme, {THEME} from './shared/assets/styles/theme'
import {ApiProvider} from './shared/api/ApiContext'
import ApiConnector from './shared/api/ApiConnector'
import AdminApi from './api/AdminApi'
import SnackMessages from './components/molecules/SnackMessages'
import ErrorHandler from './shared/components/pages/ErrorHandler'
import {
  createAsyncComponent,
  createPageWrapper
} from './shared/components/pages'
import captcha from './shared/utils/captcha'

import createGenerateClassName from '@material-ui/core/styles/createGenerateClassName'
import jssPreset from '@material-ui/core/styles/jssPreset'
import {create} from 'jss'
import rtl from 'jss-rtl'
import JssProvider from 'react-jss/lib/JssProvider'
import {SnackbarProvider} from 'notistack'

const jss = create({plugins: [...jssPreset().plugins, rtl()]})
const generateClassName = createGenerateClassName()

const apiConnector = new ApiConnector(process.env.REACT_APP_API_URL)
const adminApi = new AdminApi(apiConnector)

const componentByName = {
  ModelDetails: createAsyncComponent(() =>
    import('./components/page/ModelViewWrapper')
  ),
  ModelList: createAsyncComponent(() =>
    import('./components/page/ModelViewWrapper')
  ),

  AdminLoginPage: createAsyncComponent(() =>
    import('./components/page/AdminLoginPage')
  ),
  AdminLoginResetPage: createAsyncComponent(() =>
    import('./shared/components/pages/ResetPasswordPage')
  ),
  AdminLoginResetPasswordPage: createAsyncComponent(() =>
    import('./components/page/AdminLoginSetPasswordPage')
  ),

  AdminDashboard: createAsyncComponent(() =>
    import('./components/page/AdminDashboard')
  ),
  AdminVersionControlPage: createAsyncComponent(() =>
    import('./components/page/AdminVersionControlPage')
  ),
  AdminSynchronizationPage: createAsyncComponent(() =>
    import('./components/page/AdminSynchronizationPage')
  ),
  GenericMessagePage: createAsyncComponent(() =>
    import('./shared/components/templates/GenericMessagePage')
  )
}

const getComponentByName = name => {
  return componentByName[name]
}

let PageWrapper = createPageWrapper({
  getComponentByName,
  AppFrame,
  PopupWrapper,
  locale: 'en'
})

class App extends React.PureComponent {
  state = {}

  constructor(props) {
    super(props)

    this.state = {
      theme: createMuiTheme(THEME)
    }
  }

  handleRouteChange = ({pageData: {appFrame} = {}}) => {
    captcha(appFrame)
  }

  handleThemeChange = newTheme => {
    if (newTheme.direction) document.body.dir = newTheme.direction
    this.setState({theme: createMuiTheme({...THEME, ...newTheme})})
  }

  render() {
    const {theme} = this.state

    return (
      <JssProvider jss={jss} generateClassName={generateClassName}>
        <PortalTheme.Provider value={this.handleThemeChange}>
          <MuiThemeProvider theme={theme}>
            <BrowserRouter>
              <ErrorHandler>
                <ApiProvider api={adminApi}>
                  <SnackbarProvider maxSnack={4} dense>
                    <SnackMessages />
                    <Route
                      render={props => (
                        <PageWrapper
                          {...props}
                          onRouteChange={this.handleRouteChange}
                        />
                      )}
                    />
                  </SnackbarProvider>
                </ApiProvider>
              </ErrorHandler>
            </BrowserRouter>
          </MuiThemeProvider>
        </PortalTheme.Provider>
      </JssProvider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js